/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Req_R3Inputs */

const en_fc_online_req_r3 = /** @type {(inputs: Fc_Online_Req_R3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add ?webgl to force WebGL2, or ?cpu for the slowest but most compatible mode.`)
};

/**
* | output |
* | --- |
* | "Add ?webgl to force WebGL2, or ?cpu for the slowest but most compatible mode." |
*
* @param {Fc_Online_Req_R3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_req_r3 = /** @type {((inputs?: Fc_Online_Req_R3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Req_R3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_req_r3(inputs)
});
export { fc_online_req_r3 as "fc.online.req.r3" }